import { Box, Stack, StackProps, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)<StackProps>(
  ({ theme: { spacing, palette, customVars } }) => ({
    gap: spacing(3.2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 'fit-content',
    padding: spacing(1.4, 1.6),
    marginBottom: spacing(0.2),
    backgroundColor: palette.common.white,
    boxShadow: customVars.dropDownShadow,
    '& .phone-number': {
      minWidth: spacing(30),
    },
    '& .date': {
      minWidth: spacing(35),
    },
    '& .number-type': {
      minWidth: spacing(15),
      textAlign: 'right',
    },
    '& .enable-number': {
      minWidth: spacing(13),
      marginLeft: 'auto',
      color: palette.text.primary,
    },
    '& .stir-shaken': {
      minWidth: spacing(16),
      marginLeft: 'auto',
      color: palette.text.primary,
    },
    '& .delete-icon': {
      color: palette.text.primary,
    },
    '& .reverify-button': {
      marginLeft: 'auto',
      color: palette.text.primary,
    },
    '& .warning-text': {
      color: palette.error.main,
    },
  })
);

export const StyledForm = styled(Box)<BoxProps>(
  ({ theme: { spacing, palette, colors } }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing(2.4),
    marginBottom: spacing(2.4),
    backgroundColor: colors.tableHeader,
    '& .add-number-input': {
      backgroundColor: palette.common.white,
    },
    '& .verification-initiated-failed': {
      color: palette.error.main,
    },
    '& .pincode': {
      color: palette.secondary.main,
      fontWeight: 'bold',
    },
    '& .phone-and-warning': {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);
